import React from "react"

export const WeatherCard = ({ weather }) => {

    const iconCode = weather.weather[0].icon
    const iconUrl = `https://openweathermap.org/img/wn/${iconCode}@4x.png`

    return (
        <div className="flex flex-col items-center text-white p-4">
            <h2 className="text-center font-bold text-2xl mt-4 drop-shadow-md">
                {weather.name},{weather.sys.country}</h2>
            <div className="flex items-center my-6 bg-white/10 px-8 py-3 rounded-full border border-white/10 shadow-inner">
                <img src={iconUrl}
                    alt={weather.weather[0].description}
                    className="w-16 h-16 drop-shadow-lg animate-pulse duration-[3000ms]" />

                <p className="text-5xl font-bold tracking-tighter">
                    {Math.round(weather.main.temp)}°C</p>
            </div>

            <p className="text-center text-sm text-white/90 font-medium tracking-wide uppercase mb-8">
                {weather.weather[0].description}</p>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 w-full pt-4 sm:pt-6 ">
                <div className="flex flex-col items-center p-3 sm:p-4 bg-white/5 rounded-2xl border border-white/5 hover:bg-white/10 transition-colors">
                    <p className="text-white/50 text-[9px] sm:text-[10px] uppercase font-black tracking-widest mb-1">Humidity</p>
                    <p className="text-xl sm:text-xl font-bold">{weather.main.humidity}%</p>
                </div>
                <div className="flex flex-col items-center p-3 sm:p-4 bg-white/5 rounded-2xl border border-white/5 hover:bg-white/10 transition-colors">
                    <p className="text-white/50 text-[9px] sm:text-[10px] uppercase font-black tracking-widest mb-1">Wind</p>
                    <p className="text-xl font-bold">{weather.wind.speed} <span className="text-xs font-normal">m/s</span></p>
                </div>
                <div className="flex flex-col items-center p-3 sm:p-4 bg-white/5 rounded-2xl border border-white/5 hover:bg-white/10 transition-colors">
                    <p className="text-white/50 text-[9px] sm:text-[10px] uppercase font-black tracking-widest mb-1">Feels Like</p>
                    <p className="text-xl font-bold">{Math.round(weather.main.feels_like)}°C</p>
                </div>
                <div className="flex flex-col items-center p-3 sm:p-4 bg-white/5 rounded-2xl border border-white/5 hover:bg-white/10 transition-colors">
                    <p className="text-white/50 text-[9px] sm:text-[10px] uppercase font-black tracking-widest mb-1">Pressure</p>
                    <p className="text-xl font-bold">{weather.main.pressure} <span className="text-xs font-normal">hPa</span> </p>
                </div>

            </div>

        </div>
    )
}